import { formatHour } from "../helpers/time";
import { ScheduleFooterStyles } from "./scheduleFooter.styles";

const ScheduleFooter = ({ nowH, workersCount, jobsCount }) => (
  <ScheduleFooterStyles>
    <span className="now">
      <span className="bar" />
      Now · {formatHour(nowH)}
    </span>
    <div className="spacer" />
    <span className="counts">
      {workersCount} workers · {jobsCount} jobs shown
    </span>
  </ScheduleFooterStyles>
);

export default ScheduleFooter;
